"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkAXBL3KEB_js = require('./chunk-AXBL3KEB.js');
var chunkGOEF5BTM_js = require('./chunk-GOEF5BTM.js');
var i = require('styled-components');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var i__default = /*#__PURE__*/_interopDefaultLegacy(i);

var e=p=>{let u=chunkGOEF5BTM_js.b(),{setStart:n,setEnd:m}=chunkGOEF5BTM_js.a("ButtonGroup",u);n();let s=jsxRuntime.jsx(chunkAXBL3KEB_js.b.ButtonGroup,{...p});return m(),s};e.displayName="ButtonGroup";var l=i__default["default"](e)``;

exports.a = l;
